// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module--header--Ff9_p","logo":"style-module--logo--cf17b"};